module.exports = __webpack_public_path__ + "static/img/WeChat@2x.2d66c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/WeChat@2x.png
// module id = ZxVc
// module chunks = 44